import Service from "../../service";

const shipping = {
    getShipping(page) {
        return Service.get("/shipping-fee-history?page="+page);
    },
    createShipping(data){
        return Service.post("/shipping-fee-history" ,data);
    },
    searchCustomerShipping(page, data){
        return Service.get("/search-shipping?page="+page+
            "&customer_id="+data.customer_id+
            "&area_id="+data.area_id+
            "&province_id="+data.province_id+
            "&districts_id="+data.districts_id+
            "&sale_id="+data.sale_id
        );
    },
    searchEditShipping(page,date){
        return Service.post("/search-edit-shipping?page="+page,date);
    },
    selectAll(data){
        return Service.get("/select_all_shipping?"+
            "&name="+data.name+
            "&area_id="+data.area_id+
            "&province_id="+data.province_id+
            "&districts_id="+data.districts_id+
            "&sale_id="+data.sale_id);
    }
};
export default shipping;
